import { layout } from '../../../styled-system/recipes';
import { NotFound } from '#/components/Error';
import { useTitle } from '#/utils/useTitle';

export function NoMatch() {
  useTitle('ページが見つかりませんでした');
  const { errorContainer } = layout();
  return (
    <div className={errorContainer}>
      <NotFound />
    </div>
  );
}
